import { render, staticRenderFns } from "./EcommerceProductLineDetail.vue?vue&type=template&id=52687ed8&lang=pug&"
import script from "./EcommerceProductLineDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcommerceProductLineDetail.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports